<template>
  <b-table
    striped
    small
    responsive
    no-border-collapse
    bordered
    sticky-header
    :items="excelData"
    :fields="TABLE_FIELDS"
  >
    <!-- Enlace -->
    <template #head(enlace)>
      <div class="text-nowrap text-center">
        Enlace
      </div>
    </template>

    <!-- Nombre -->
    <template #head(nombre)>
      <div class="text-nowrap text-center">
        Nombre
      </div>
    </template>

    <!-- Segundo nombre -->
    <template #head(segundoNombre)>
      <div class="text-nowrap text-center">
        Segundo Nombre
      </div>
    </template>

    <!-- Apellido paterno -->
    <template #head(apellidoPaterno)>
      <div class="text-nowrap text-center">
        Apellido paterno
      </div>
    </template>

    <!-- Apellido materno -->
    <template #head(apellidoMaterno)>
      <div class="text-nowrap text-center">
        Apellido materno
      </div>
    </template>

    <!-- Correo electrónico -->
    <template #head(correo)>
      <div class="text-nowrap text-center">
        Correo electrónico
      </div>
    </template>

    <!-- Correo electrónico alternativo -->
    <template #head(correoAlt)>
      <div class="text-nowrap text-center">
        Correo electrónico alternativo
      </div>
    </template>

    <!-- Teléfono 1 -->
    <template #head(telefono1)>
      <div class="text-nowrap text-center">
        Teléfono 1
      </div>
    </template>

    <!-- Teléfono 2 -->
    <template #head(telefono2)>
      <div class="text-nowrap text-center">
        Teléfono 2
      </div>
    </template>

    <!-- Extensión -->
    <template #head(extension)>
      <div class="text-nowrap text-center">
        Extensión
      </div>
    </template>

    <!-- CURP -->
    <template #head(curp)>
      <div class="text-nowrap text-center">
        CURP
      </div>
    </template>

    <!-- Nacionalidad -->
    <template #head(nacionalidad)>
      <div class="text-nowrap text-center">
        Nacionalidad
      </div>
    </template>

    <!-- Tipo de gobierno -->
    <template #head(tipoGobierno)>
      <div class="text-nowrap text-center">
        Tipo de gobierno
      </div>
    </template>

    <!-- Entidad Federativa -->
    <template #head(entidadFederativa)>
      <div class="text-nowrap text-center">
        Entidad Federativa
      </div>
    </template>

    <!-- Municipio -->
    <template #head(municipio)>
      <div class="text-nowrap text-center">
        Municipio
      </div>
    </template>

    <!-- Dependencia -->
    <template #head(dependencia)>
      <div class="text-nowrap text-center">
        Dependencia
      </div>
    </template>

    <!-- Puesto / Cargo -->
    <template #head(puesto)>
      <div class="text-nowrap text-center">
        Puesto / Cargo
      </div>
    </template>

    <!-- Grado -->
    <template #head(grado)>
      <div class="text-nowrap text-center">
        Grado
      </div>
    </template>

    <!-- Departamento -->
    <template #head(departamento)>
      <div class="text-nowrap text-center">
        Departamento
      </div>
    </template>

    <!-- Carrera -->
    <template #head(carrera)>
      <div class="text-nowrap text-center">
        Carrera
      </div>
    </template>

    <!-- Cédula -->
    <template #head(cedula)>
      <div class="text-nowrap text-center">
        Cédula
      </div>
    </template>

    <!-- Entidad Federativa de titulación -->
    <template #head(efTitulacion)>
      <div class="text-nowrap text-center">
        Entidad Federativa de titulación
      </div>
    </template>

    <!-- Institución Educativa -->
    <template #head(instEducativa)>
      <div class="text-nowrap text-center">
        Institución Educativa
      </div>
    </template>

    <!-- Clave de Centro de Trabajo (CCT) -->
    <template #head(cct)>
      <div class="text-nowrap text-center">
        Clave de Centro de Trabajo (CCT)
      </div>
    </template>

    <!-- Fecha de expedición de cédula -->
    <template #head(fechaExpCedula)>
      <div class="text-nowrap text-center">
        Fecha de expedición de cédula
      </div>
    </template>

    <!-- Enlace -->
    <template #cell(enlace)="data">
      <p class="text-center m-0">
        <strong>{{ data.value ? 'ENLACE' : '' }}</strong>
      </p>
    </template>

    <!-- Nombre -->
    <template #cell(nombre)="data">
      <p class="text-nowrap m-0">
        {{ data.value ? data.value.trim().toUpperCase() : '' }}
      </p>
    </template>

    <!-- Segundo nombre -->
    <template #cell(segundoNombre)="data">
      <p class="text-nowrap m-0">
        {{ data.value ? data.value.trim().toUpperCase() : '' }}
      </p>
    </template>

    <!-- Apellido Paterno -->
    <template #cell(apellidoPaterno)="data">
      <p class="text-nowrap m-0">
        {{ data.value ? data.value.trim().toUpperCase() : '' }}
      </p>
    </template>

    <!-- Apellido Materno -->
    <template #cell(apellidoMaterno)="data">
      <p class="text-nowrap m-0">
        {{ data.value ? data.value.trim().toUpperCase() : '' }}
      </p>
    </template>

    <!-- Correo electrónico -->
    <template #cell(correo)="data">
      <p class="text-nowrap text-center m-0">
        <strong>{{ data.value }}</strong>
      </p>
    </template>

    <!-- Correo electrónico alternativo -->
    <template #cell(correoAlt)="data">
      <p class="text-nowrap text-center m-0">
        <strong>{{ data.value }}</strong>
      </p>
    </template>

    <!-- Teléfono 1 -->
    <template #cell(telefono1)="data">
      <p class="text-center m-0">
        {{ data.value }}
      </p>
    </template>

    <!-- Teléfono 2 -->
    <template #cell(telefono2)="data">
      <p class="text-center m-0">
        {{ data.value }}
      </p>
    </template>

    <!-- Extensión -->
    <template #cell(extension)="data">
      <p class="text-center m-0">
        {{ data.value }}
      </p>
    </template>

    <!-- CURP -->
    <template #cell(curp)="data">
      <p class="text-center m-0">
        <strong>{{ data.value }}</strong>
      </p>
    </template>

    <!-- Nacionalidad -->
    <template #cell(nacionalidad)="data">
      <p class="text-center m-0">
        {{ data.value }}
      </p>
    </template>

    <!-- Tipo de gobierno -->
    <template #cell(tipoGobierno)="data">
      <p
        class="m-0"
        :class="{'text-danger': !data.item.id_tipo_gob}"
        style="white-space: nowrap;"
      >
        <small
          v-if="!!data.item.id_tipo_gob"
          v-b-tooltip.hover.right="'Tipo de gobierno validado y asignado'"
          class="cursor-default"
        >
          ✅
        </small>

        {{ data.value }}
      </p>
    </template>

    <!-- Entidad Federativa -->
    <template #cell(entidadFederativa)="data">
      <p
        class="m-0"
        :class="{'text-danger': !data.item.id_entidadFederativaDep || data.item.id_entidadFederativaDep === UNKNOWN_IDS.entidadFederativa}"
        style="white-space: nowrap;"
      >
        <small
          v-if="data.item.id_entidadFederativaDep && data.item.id_entidadFederativaDep !== UNKNOWN_IDS.entidadFederativa && data.item.tipoGobierno.toLowerCase() !== 'federal'"
          v-b-tooltip.hover.right="'Entidad federativa validada y asignada'"
          class="cursor-default"
        >
          ✅
        </small>

        {{ data.item.id_entidadFederativaDep && data.item.id_entidadFederativaDep !== UNKNOWN_IDS.entidadFederativa ? data.item.nombre_entidadFederativaDep : data.value }}
      </p>
    </template>

    <!-- Municipio -->
    <template #cell(municipio)="data">
      <p
        class="m-0"
        :class="{'text-danger': !data.item.id_municipio}"
        style="white-space: nowrap;"
      >
        <small
          v-if="data.item.id_municipio && data.item.tipoGobierno.toLowerCase() === 'municipal'"
          v-b-tooltip.hover.right="'Municipio validado y asignado'"
          class="cursor-default"
        >
          ✅
        </small>

        {{ data.item.tipoGobierno.toLowerCase() === 'municipal' ? data.item.nombre_municipio || data.value : '' }}
      </p>
    </template>

    <!-- Dependencia -->
    <template #cell(dependencia)="data">
      <p
        class="m-0"
        :class="{'text-danger': !data.item.id_dependencia || data.item.id_dependencia === UNKNOWN_IDS.dependencia}"
        style="white-space: nowrap;"
      >
        <small
          v-if="data.item.id_dependencia && data.item.id_dependencia !== UNKNOWN_IDS.dependencia && data.item.tipoGobierno.toLowerCase() !== 'municipal'"
          v-b-tooltip.hover.right="'Dependencia validada y asignada'"
          class="cursor-default"
        >
          ✅
        </small>

        {{ data.item.tipoGobierno.toLowerCase() !== 'municipal' ? data.item.nombre_dependencia || data.value : '' }}
      </p>
    </template>

    <!-- Puesto / Cargo -->
    <template #cell(puesto)="data">
      <p
        class="m-0"
        :class="{'text-danger': !data.item.id_puesto || data.item.id_puesto === UNKNOWN_IDS.puesto}"
        style="white-space: nowrap;"
      >
        <small
          v-if="data.item.id_puesto && data.item.id_puesto !== UNKNOWN_IDS.puesto"
          v-b-tooltip.hover.right="'Puesto validado y asignado'"
          class="cursor-default"
        >
          ✅
        </small>

        {{ data.item.nombre_puesto || data.value.trim().toUpperCase() }}
      </p>
    </template>

    <!-- Grado -->
    <template #cell(grado)="data">
      <p
        class="m-0"
        :class="{'text-danger': !data.item.id_grado || data.item.id_grado === UNKNOWN_IDS.grado}"
        style="white-space: nowrap;"
      >
        <small
          v-if="data.item.id_grado && data.item.id_grado !== UNKNOWN_IDS.grado"
          v-b-tooltip.hover.right="'Grado validado y asignado'"
          class="cursor-default"
        >
          ✅
        </small>

        {{ data.item.nombre_grado || data.value.trim().toUpperCase() }}
      </p>
    </template>

    <!-- Departamento -->
    <template #cell(departamento)="data">
      <p
        class="m-0"
        :class="{'text-danger': !data.item.id_departamento || data.item.id_departamento === UNKNOWN_IDS.departamento}"
        style="white-space: nowrap;"
      >
        <small
          v-if="data.item.id_departamento && data.item.id_departamento !== UNKNOWN_IDS.departamento"
          v-b-tooltip.hover.right="'Departamento validado y asignado'"
          class="cursor-default"
        >
          ✅
        </small>

        {{ data.item.nombre_departamento || data.value.trim().toUpperCase() }}
      </p>
    </template>

    <!-- Carrera -->
    <template #cell(carrera)="data">
      <p
        class="m-0"
        style="white-space: nowrap;"
      >
        {{ data.value.trim().toUpperCase() }}
      </p>
    </template>

    <!-- Cédula -->
    <template #cell(cedula)="data">
      <p
        class="m-0"
        style="white-space: nowrap;"
      >
        {{ data.value.trim().toUpperCase() }}
      </p>
    </template>

    <!-- Entidad Federativa de Titulación -->
    <template #cell(efTitulacion)="data">
      <p
        class="m-0"
        :class="{'text-danger': !data.item.id_entidadFederativa || data.item.id_entidadFederativa === UNKNOWN_IDS.entidadFederativa}"
        style="white-space: nowrap;"
      >
        <small
          v-if="data.item.id_entidadFederativa && data.item.id_entidadFederativa !== UNKNOWN_IDS.entidadFederativa"
          v-b-tooltip.hover.right="'Entidad federativa validada y asignada'"
          class="cursor-default"
        >
          ✅
        </small>

        <!-- {{ data.item.nombre_entidadFederativa || data.value.trim().toUpperCase() }} -->
        {{ data.item.id_entidadFederativa && data.item.id_entidadFederativa !== UNKNOWN_IDS.entidadFederativa ? data.item.nombre_entidadFederativa : data.value }}

      </p>
    </template>

    <!-- Institución Educativa -->
    <template #cell(instEducativa)="data">
      <p
        class="m-0"
        style="white-space: nowrap;"
      >
        {{ data.value.trim().toUpperCase() }}
      </p>
    </template>

    <!-- CCT -->
    <template #cell(cct)="data">
      <p
        class="m-0"
        style="white-space: nowrap;"
      >
        {{ data.value.trim().toUpperCase() }}
      </p>
    </template>

    <!-- Fecha de expedición de cédula -->
    <template #cell(fechaExpCedula)="data">
      <p
        class="m-0"
        style="white-space: nowrap;"
      >
        {{ data.value }}
      </p>
    </template>
  </b-table>
</template>

<script>
import { VBTooltip, BTable } from 'bootstrap-vue'
import { TABLE_FIELDS, UNKNOWN_IDS } from '../useMassiveRegister'

export default {
  components: {
    BTable,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    excelData: {
      type: Array,
      required: true,
    },
  },
  setup() {
    return { TABLE_FIELDS, UNKNOWN_IDS }
  },
}
</script>
